import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import CardDesktop from './CardDesktop';
import { cardsInfo } from './cardsInfo';

function CardsBoxDesktop() {
  const [credit, debit] = cardsInfo;

  return (
    <Box
      display="flex"
      marginTop="18x"
      marginBottom="180px"
      tag="section"
      flexDirection="row"
      justifyContent="center"
      alignItems="flex-start"
      key="credit"
      paddingHorizontal={{ md: '8x', lg: '12x' }}
      width="100%"
    >
      {/* CREDIT CARD */}

      <Box
        marginRight={{ md: '48px', lg: '100px' }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex="1 1 0"
        minWidth="0"
        maxWidth={{ md: '360px', lg: '447px' }}
      >
        <CardDesktop {...credit} />
      </Box>

      {/* DEBIT CARD */}

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        key="debit"
        flex="1 1 0"
        minWidth="0"
        maxWidth={{ md: '360px', lg: '447px' }}
      >
        <CardDesktop {...debit} />
      </Box>
    </Box>
  );
}

export default CardsBoxDesktop;
